// Lib
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Utils
import { isInstalledPwa } from './pwaUtils';

// Constants
import { PWA_APP_INSTALLED } from './store/pwaAppConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchPwaAppInstall: () => dispatch({ type: PWA_APP_INSTALLED }),
});

const PwaDetection = (props) => {
    const { dispatchPwaAppInstall } = props;

    React.useEffect(() => {
        const onAppInstalled = () => {
            // Give the app a chance to complete installation
            setTimeout(() => {
                const isInstalled = isInstalledPwa();
                if (isInstalled) dispatchPwaAppInstall();
            }, 2000);
        };

        window.addEventListener('appinstalled', onAppInstalled);

        return () => {
            window.removeEventListener('appinstalled', onAppInstalled);
        };
    }, []);

    return null;
};

PwaDetection.propTypes = {
    dispatchPwaAppInstall: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(PwaDetection);
